var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-none",class:{'cookie-disclaimer__cta': _vm.thickBorder},style:(_vm.buttonStyles),attrs:{"id":_vm.gtmId,"outlined":_vm.isOutlined,"text":"","block":""},on:{"click":function($event){$event.preventDefault();return _vm.clickAction.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa07b9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gdpr/components/DisclaimerButton.vue
// module id = null
// module chunks = 